import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { SEARCH_MEMBERS_QUERY } from '@frontend/app/queries';
import {
  SearchMembersQuery,
  SearchMembersQueryVariables,
} from '@frontend/app/queries/types/SearchMembersQuery';
import { useSearchTextQuery } from '@frontend/app/components/MemberTable/hooks';

const SEARCH_MEMBER_FIELDS = [
  // member fields that will be searched
  'First Name',
  'Instagram',
  'Last Name',
  'Pinterest',
  'TikTok',
  'YouTube',
];

/**
 * Hook for searching members by search term
 * @param value Search term to filter members by name
 * @returns Object with members data, loading state, and error
 */
export const useSearchMembers = (value: string) => {
  const { getSearchTextQuery } = useSearchTextQuery({
    memberFields: SEARCH_MEMBER_FIELDS,
  });
  const { data, loading, error } = useQuery<SearchMembersQuery, SearchMembersQueryVariables>(
    SEARCH_MEMBERS_QUERY,
    {
      variables: {
        query: getSearchTextQuery(value),
        take: 100,
        skip: 0,
      },
      skip: !value,
      fetchPolicy: 'no-cache',
    }
  );

  // Memoize the result to prevent unnecessary re-renders
  const result = useMemo(() => ({
    data,
    loading,
    error
  }), [data, loading, error]);

  return result;
};
